import axios from "axios";
import { BACKEND_URL } from "../../global";
import keycloak from "../../keycloak";

export function transcribeFile(fileId) {
    axios.post(BACKEND_URL + '/transcribe/' + fileId, {}, { headers: { Authorization: `Bearer ${keycloak.token}` } });
}
export default transcribeFile;